import { Row, Col } from "react-bootstrap"
import React, { useState } from "react"
import { CourseHeaderButton } from "./course_header_button"
import { useSelector } from "react-redux"
import { ImportCourseModal } from "./import_course_modal"
import { CopyCourseModal } from "./copy_course_modal"

export const CourseButtonsRow = () => {

  const addCourseUrl = useSelector((state) => state?.misc?.data?.routes?.addCourseUrl)
  const [showImportModal, setShowImportModal] = useState(false)
  const [showCopyModal, setShowCopyModal] = useState(false)

  return(
    <div className="button-row">
      <div className="left-buttons-container">
        <CourseHeaderButton url={addCourseUrl} text='Add a Course'/>
        <CourseHeaderButton onClick={() => setShowImportModal(true)} text='Import from USGA Course Rating Directory'/>
      </div>
      <CourseHeaderButton onClick={() => setShowCopyModal(true)} extraStyling='pull-right' text='[Admin] Copy in a Course'/>
      <ImportCourseModal show={showImportModal} setShow={setShowImportModal}/>
      <CopyCourseModal show={showCopyModal} setShow={(setShowCopyModal)}/>
    </div>
  )
}